import {AysFab} from './fab.model';

new AysFab('1500', 'Allgemeinchirurgie');
new AysFab('2900', 'Allgemeine Psychiatrie');
new AysFab('2700', 'Augenheilkunde');
new AysFab('0600', 'Endokrinologie');
new AysFab('2400', 'Frauenheilkunde und Geburtshilfe');
new AysFab('0700', 'Gastroenterologie');
new AysFab('1800', 'Gefäßchirurgie');
new AysFab('0200', 'Geriatrie');
new AysFab('2600', 'Hals-, Nasen-, Ohrenheilkunde');
new AysFab('1551', 'Handchirurgie');
new AysFab('2100', 'Herzchirurgie');
new AysFab('0500', 'Hämatologie und internistische Onkologie');
new AysFab('0100', 'Innere Medizin');
new AysFab('3600', 'Intensivmedizin');
new AysFab('0300', 'Kardiologie');
new AysFab('1700', 'Neurochirurgie');
new AysFab('2800', 'Neurologie');
new AysFab('2316', 'Orthopädie und Unfallchirurgie');
new AysFab('1900', 'Plastische Chirurgie');
new AysFab('0800', 'Pneumologie');
new AysFab('3100', 'Psychosomatik/Psychotherapie');
new AysFab('1000', 'Pädiatrie');
new AysFab('3300', 'Strahlenheilkunde');
new AysFab('2000', 'Thoraxchirurgie');
new AysFab('2200', 'Urologie');
new AysFab('2500', 'Geburtshilfe');
/**
 * @deprecated do not use static values any more, fetch for each virtual clinic !
 */
export const AYS_FABS = [
  new AysFab('1500', 'Allgemeinchirurgie'),
  new AysFab('2900', 'Allgemeine Psychiatrie'),
  new AysFab('2700', 'Augenheilkunde'),
  new AysFab('3400', 'Dermatologie'),
  new AysFab('0600', 'Endokrinologie'),
  new AysFab('2400', 'Frauenheilkunde und Geburtshilfe'),
  new AysFab('0700', 'Gastroenterologie'),
  new AysFab('1800', 'Gefäßchirurgie'),
  new AysFab('0200', 'Geriatrie'),
  new AysFab('2600', 'Hals-, Nasen-, Ohrenheilkunde'),
  new AysFab('1551', 'Handchirurgie'),
  new AysFab('2100', 'Herzchirurgie'),
  new AysFab('0500', 'Hämatologie und internistische Onkologie'),
  new AysFab('0100', 'Innere Medizin'),
  new AysFab('3600', 'Intensivmedizin'),
  new AysFab('0300', 'Kardiologie'),
  new AysFab('3000', 'Kinder- und Jugendpsychiatrie'),
  new AysFab('1300', 'Kinderchirurgie'),
  new AysFab('1100', 'Kinderkardiologie'),
  new AysFab('1400', 'Lungen- und Bronchialheilkunde'),
  new AysFab('1200', 'Neonatologie'),
  new AysFab('0400', 'Nephrologie'),
  new AysFab('1700', 'Neurochirurgie'),
  new AysFab('2800', 'Neurologie'),
  new AysFab('3200', 'Nuklearmedizin'),
  new AysFab('2300', 'Orthopädie'),
  new AysFab('2316', 'Orthopädie und Unfallchirurgie'),
  new AysFab('1900', 'Plastische Chirurgie'),
  new AysFab('0800', 'Pneumologie'),
  new AysFab('3100', 'Psychosomatik/Psychotherapie'),
  new AysFab('1000', 'Pädiatrie'),
  new AysFab('0900', 'Rheumatologie'),
  new AysFab('3753', 'Schmerztherapie'),
  new AysFab('0000', 'Sonstige'),
  new AysFab('3700', 'Sonstige Fachabteilung'),
  new AysFab('3300', 'Strahlenheilkunde'),
  new AysFab('2000', 'Thoraxchirurgie'),
  new AysFab('1600', 'Unfallchirurgie'),
  new AysFab('2200', 'Urologie'),
  new AysFab('3500', 'Zahn- und Kieferheilkunde, Mund- und Kieferchirurgie'),
  new AysFab('2500', 'davon Geburtshilfe')
];

/**
 * @deprecated do not use static values any more, fetch for each virtual clinic !
 */
export const AYS_FABS_EXTENDED = [
  new AysFab('0000', 'Unbekannt'),
  new AysFab('0100', 'Innere Medizin'),
  new AysFab('2400', 'Frauenheilkunde'),
  new AysFab('2500', 'Geburtshilfe'),
  new AysFab('0200', 'Geriatrie'),
  new AysFab('0300', 'Kardiologie'),
  new AysFab('0400', 'Nephrologie'),
  new AysFab('0500', 'Hämatologie und internistische Onkologie'),
  new AysFab('0600', 'Endokrinologie'),
  new AysFab('0700', 'Gastroenterologie'),
  new AysFab('0800', 'Pneumologie'),
  new AysFab('0900', 'Rheumatologie'),
  new AysFab('1000', 'Pädiatrie'),
  new AysFab('1100', 'Kinderkardiologie'),
  new AysFab('1200', 'Neonatologie'),
  new AysFab('1300', 'Kinderchirurgie'),
  new AysFab('1400', 'Lungen- und Bronchialheilkunde'),
  new AysFab('1500', 'Allgemeinchirurgie'),
  new AysFab('1600', 'Unfallchirurgie'),
  new AysFab('1700', 'Neurochirurgie'),
  new AysFab('1800', 'Gefäßchirurgie'),
  new AysFab('1900', 'Plastische Chirurgie'),
  new AysFab('2000', 'Thoraxchirurgie'),
  new AysFab('2100', 'Herzchirurgie'),
  new AysFab('2200', 'Urologie'),
  new AysFab('2300', 'Orthopädie'),
  new AysFab('2600', 'Hals-, Nasen-, Ohrenheilkunde'),
  new AysFab('2700', 'Augenheilkunde'),
  new AysFab('2800', 'Neurologie'),
  new AysFab('2900', 'Allgemeine Psychiatrie'),
  new AysFab('3000', 'Kinder- und Jugendpsychiatrie'),
  new AysFab('3100', 'Psychosomatik/Psychotherapie'),
  new AysFab('3200', 'Nuklearmedizin'),
  new AysFab('3300', 'Strahlenheilkunde'),
  new AysFab('3400', 'Dermatologie'),
  new AysFab('3500', 'Zahn- und Kieferheilkunde, Mund- und Kieferchirurgie'),
  new AysFab('3600', 'Intensivmedizin'),
  new AysFab('3700', 'Sonstige Fachabteilung'),
  new AysFab('2316', 'Orthopädie und Unfallchirurgie'),
  new AysFab('0104', 'Innere Medizin/Schwerpunkt Nephrologie'),
  new AysFab('0105', 'Innere Medizin/Schwerpunkt Hämatologie und internistische Onkologie'),
  new AysFab('0106', 'Innere Medizin/Schwerpunkt Endokrinologie'),
  new AysFab('0107', 'Innere Medizin/Schwerpunkt Gastroenterologie'),
  new AysFab('0108', 'Innere Medizin/Schwerpunkt Pneumologie'),
  new AysFab('0109', 'Innere Medizin/Schwerpunkt Rheumatologie'),
  new AysFab('0114', 'Innere Medizin/Schwerpunkt Lungen- und Bronchialheilkunde'),
  new AysFab('0150', 'Innere Medizin/Tumorforschung'),
  new AysFab('0151', 'Innere Medizin/Schwerpunkt Coloproktologie'),
  new AysFab('0152', 'Innere Medizin/Schwerpunkt Infektionskrankheiten'),
  new AysFab('0153', 'Innere Medizin/Schwerpunkt Diabetes'),
  new AysFab('0154', 'Innere Medizin/Schwerpunkt Naturheilkunde'),
  new AysFab('0224', 'Geriatrie/Schwerpunkt Frauenheilkunde'),
  new AysFab('0260', 'Geriatrie/Tagesklinik (für teilstationäre Pflegesätze)'),
  new AysFab('0261', 'Geriatrie/Nachtklinik (für teilstationäre Pflegesätze)'),
  new AysFab('0410', 'Nephrologie/Schwerpunkt Pädiatrie'),
  new AysFab('0436', 'Nephrologie/Intensivmedizin'),
  new AysFab('0510', 'Hämatologie und internistische Onkologie/Schwerpunkt Pädiatrie'),
  new AysFab('0524', 'Hämatologie und internistische Onkologie/Schwerpunkt Frauenheilkunde'),
  new AysFab('0533', 'Hämatologie und internistische Onkologie/Schwerpunkt Strahlenheilkunde'),
  new AysFab('0607', 'Endokrinologie/Schwerpunkt Gastroenterologie'),
  new AysFab('0610', 'Endokrinologie/Schwerpunkt Pädiatrie'),
  new AysFab('0706', 'Gastroenterologie/Schwerpunkt Endokrinologie'),
  new AysFab('0710', 'Gastroenterologie/Schwerpunkt Pädiatrie'),
  new AysFab('0910', 'Rheumatologie/Schwerpunkt Pädiatrie'),
  new AysFab('1004', 'Pädiatrie/Schwerpunkt Nephrologie'),
  new AysFab('1005', 'Pädiatrie/Schwerpunkt Hämatologie und internistische Onkologie'),
  new AysFab('1006', 'Pädiatrie/Schwerpunkt Endokrinologie '),
  new AysFab('3750', 'Angiologie'),
  new AysFab('0156', 'Innere Medizin/Schwerpunkt Schlaganfallpatienten'),
  new AysFab('1007', 'Pädiatrie/Schwerpunkt Gastroenterologie'),
  new AysFab('1009', 'Pädiatrie/Schwerpunkt Rheumatologie'),
  new AysFab('1011', 'Pädiatrie/Schwerpunkt Kinderkardiologie'),
  new AysFab('1012', 'Pädiatrie/Schwerpunkt Neonatologie'),
  new AysFab('1014', 'Pädiatrie/Schwerpunkt Lungen- und Bronchialheilkunde'),
  new AysFab('1028', 'Pädiatrie/Schwerpunkt Kinderneurologie'),
  new AysFab('1050', 'Pädiatrie/Schwerpunkt Perinatalmedizin'),
  new AysFab('1051', 'Langzeitbereich Kinder'),
  new AysFab('1136', 'Kinderkardiologie/Schwerpunkt Intensivmedizin'),
  new AysFab('1410', 'Lungen- und Bronchialheilkunde/Schwerpunkt Pädiatrie'),
  new AysFab('1513', 'Allgemeine Chirurgie/Schwerpunkt Kinderchirurgie'),
  new AysFab('1516', 'Allgemeine Chirurgie/Schwerpunkt Unfallchirurgie'),
  new AysFab('1518', 'Allgemeine Chirurgie/Schwerpunkt Gefäßchirurgie'),
  new AysFab('1519', 'Allgemeine Chirurgie/Schwerpunkt Plastische Chirurgie'),
  new AysFab('1520', 'Allgemeine Chirurgie/Schwerpunkt Thoraxchirurgie'),
  new AysFab('1523', 'Chirurgie/Schwerpunkt Orthopädie'),
  new AysFab('1550', 'Allgemeine Chirurgie/Schwerpunkt Abdominal- und Gefäßchirurgie'),
  new AysFab('1551', 'Allgemeine Chirurgie/Schwerpunkt Handchirurgie'),
  new AysFab('2021', 'Thoraxchirurgie/Schwerpunkt Herzchirurgie'),
  new AysFab('2036', 'Thoraxchirurgie/Intensivmedizin'),
  new AysFab('2050', 'Thoraxchirurgie/Schwerpunkt Herzchirurgie Intensivmedizin'),
  new AysFab('2120', 'Herzchirurgie/Schwerpunkt Thoraxchirurgie'),
  new AysFab('2150', 'Herzchirurgie/Schwerpunkt Thoraxchirurgie Intensivmedizin'),
  new AysFab('2309', 'Orthopädie/Schwerpunkt Rheumatologie'),
  new AysFab('2315', 'Orthopädie/Schwerpunkt Chirurgie'),
  new AysFab('2402', 'Frauenheilkunde/Schwerpunkt Geriatrie'),
  new AysFab('2405', 'Frauenheilkunde/Schwerpunkt Hämatologie und internistische Onkologie'),
  new AysFab('2406', 'Frauenheilkunde/Schwerpunkt Endokrinologie'),
  new AysFab('2810', 'Neurologie/Schwerpunkt Pädiatrie'),
  new AysFab('2928', 'Allgemeine Psychiatrie/Schwerpunkt Neurologie'),
  new AysFab('2930', 'Allgemeine Psychiatrie/Schwerpunkt Kinder- und Jugendpsychiatrie'),
  new AysFab('0103', 'Innere Medizin/Schwerpunkt Kardiologie'),
  new AysFab('2931', 'Allgemeine Psychiatrie/Schwerpunkt Psychosomatik/Psychotherapie'),
  new AysFab('2950', 'Allgemeine Psychiatrie/Schwerpunkt Suchtbehandlung'),
  new AysFab('2951', 'Allgemeine Psychiatrie/Schwerpunkt Gerontopsychiatrie'),
  new AysFab('2952', 'Allgemeine Psychiatrie/Schwerpunkt Forensische Behandlung'),
  new AysFab('2953', 'Allgemeine Psychiatrie/Schwerpunkt Suchtbehandlung, Tagesklinik'),
  new AysFab('2954', 'Allgemeine Psychiatrie/Schwerpunkt Suchtbehandlung, Nachtklinik'),
  new AysFab('2955', 'Allgemeine Psychiatrie/Schwerpunkt Gerontopsychiatrie, Tagesklinik'),
  new AysFab('2956', 'Allgemeine Psychiatrie/Schwerpunkt Gerontopsychiatrie, Nachtklinik'),
  new AysFab('2960', 'Allgemeine Psychiatrie/Tagesklinik (für teilstationäre Pflegesätze)'),
  new AysFab('2961', 'Allgemeine Psychiatrie/Nachtklinik (für teilstationäre Pflegesätze)'),
  new AysFab('3060', 'Kinder- und Jugendpsychiatrie/Tagesklinik (für teilstationäre Pflegesätze)'),
  new AysFab('3061', 'Kinder- und Jugendpsychiatrie/Nachtklinik (für teilstationäre Pflegesätze)'),
  new AysFab('3160', 'Psychosomatik/Psychotherapie/Tagesklinik (für teilstationäre Pflegesätze)'),
  new AysFab('3161', 'Psychosomatik/Psychotherapie/Nachtklinik (für teilstationäre Pflegesätze)'),
  new AysFab('3233', 'Nuklearmedizin/Schwerpunkt Strahlenheilkunde'),
  new AysFab('3305', 'Strahlenheilkunde/Schwerpunkt Hämatologie und internistische Onkologie'),
  new AysFab('3350', 'Strahlenheilkunde/Schwerpunkt Radiologie'),
  new AysFab('3460', 'Dermatologie/Tagesklinik (für teilstationäre Pflegesätze)'),
  new AysFab('3601', 'Intensivmedizin/Schwerpunkt Innere Medizin'),
  new AysFab('3603', 'Intensivmedizin/Schwerpunkt Kardiologie'),
  new AysFab('3610', 'Intensivmedizin/Schwerpunkt Pädiatrie'),
  new AysFab('3617', 'Intensivmedizin/Schwerpunkt Neurochirurgie'),
  new AysFab('3618', 'Intensivmedizin/Schwerpunkt Chirurgie'),
  new AysFab('3621', 'Intensivmedizin/Schwerpunkt Herzchirurgie'),
  new AysFab('3622', 'Intensivmedizin/Schwerpunkt Urologie'),
  new AysFab('3624', 'Intensivmedizin/Schwerpunkt Frauenheilkunde und Geburtshilfe'),
  new AysFab('3626', 'Intensivmedizin/Schwerpunkt Hals-, Nasen-, Ohrenheilkunde'),
  new AysFab('3628', 'Intensivmedizin/Schwerpunkt Neurologie'),
  new AysFab('3650', 'Operative Intensivmedizin/Schwerpunkt Chirurgie'),
  new AysFab('3651', 'Intensivmedizin/Thorax-Herzchirurgie'),
  new AysFab('3652', 'Intensivmedizin/Herz-Thoraxchirurgie'),
  new AysFab('3751', 'Radiologie'),
  new AysFab('3752', 'Palliativmedizin'),
  new AysFab('3753', 'Schmerztherapie'),
  new AysFab('3754', 'Heiltherapeutische Abteilung'),
  new AysFab('3755', 'Wirbelsäulenchirurgie'),
  new AysFab('3756', 'Suchtmedizin'),
  new AysFab('3757', 'Visceralchirurgie'),
  new AysFab('1536', 'Allgemeine Chirurgie/Intensivmedizin'),
  new AysFab('2136', 'Herzchirurgie/Intensivmedizin'),
  new AysFab('2856', 'Neurologie/Schwerpunkt Schlaganfallpatienten')
];
